import { Component, inject, input, OnInit } from '@angular/core'
import { Day, Doctor, Week } from 'src/app/shared/services/ppv.api'
import { VetSchedulePlannerService } from '../vet-schedule-planner.service'
import * as EnumHelper from '../enum-helper'

@Component({
   selector: 'vsp-table-cell',
   standalone: false,
   templateUrl: './table-cell.component.html',
   styleUrl: './table-cell.component.scss',
})
export class TableCellComponent implements OnInit {
   service = inject(VetSchedulePlannerService)
   day = input<Day>()
   doctor = input<Doctor>()
   dayTypes = EnumHelper.dayTypesShort
   shiftTypes = EnumHelper.shiftTypes
   isTimelessShiftType = EnumHelper.isTimelessShiftType
   constructor() {}
   ngOnInit(): void {}
}
